import { getContractAttributes } from "@bkry/bowline-redux/contracts";
import {
  getUnlockBoundaryAttributes,
  getUnlockBoundaryRelationships,
} from "@bkry/bowline-redux/unlockBoundaries";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";
import { Badge, CardImg } from "reactstrap";
import { getTraitTypesUnlockBoundaries } from "@bkry/bowline-redux/traitTypesUnlockBoundaries";
import { getTraitTypeAttributes } from "@bkry/bowline-redux/traitTypes";

const TribeBoundaryCard = ({ unlockBoundaryId }, context) => {
  const unlockBoundaryData = useSelector((state) =>
    getUnlockBoundaryAttributes(state, unlockBoundaryId)
  );

  const unlockBoundaryRelationships = useSelector((state) =>
    getUnlockBoundaryRelationships(state, unlockBoundaryId)
  );
  const tokenSample = unlockBoundaryData?.token_sample;
  console.log("tokenSample", tokenSample);

  const contractData = useSelector((state) =>
    getContractAttributes(
      state,
      unlockBoundaryData?.contract_address + "," + unlockBoundaryData?.network
    )
  );

  const boundaryTraits = useSelector((state) =>
    getTraitTypesUnlockBoundaries(
      state,
      unlockBoundaryRelationships?.trait_types_unlock_boundaries?.data?.map(
        (traitType) => traitType.id
      )
    )
  );

  const prettyTraits = boundaryTraits?.map((boundaryTrait) => {
    const traitTypeData = useSelector((state) =>
      getTraitTypeAttributes(state, boundaryTrait?.attributes?.trait_type_id)
    );

    return `${traitTypeData?.name?.toLowerCase()} ${boundaryTrait?.attributes?.value?.toLowerCase()}`;
  });

  const renderBoundaryType = () => {
    switch (unlockBoundaryData?.unlock_boundary_type) {
      case "trait":
        return `Token with ${prettyTraits?.join(" and ")}`;
      case "token":
        return `${contractData?.name} Identifier ${unlockBoundaryData?.token_id}`;
      case "contract":
        return context.t("Any {contract} Token", {
          contract: contractData?.name,
        });
      default:
        return unlockBoundaryData?.unlock_boundary_type;
    }
  };

  return (
    <div>
      <div
        className={classNames(
          "ratio ratio-1x1 border border-3",
          tokenSample?.from_wallet
            ? "border-success"
            : "border-white opacity-75"
        )}
      >
        {tokenSample && tokenSample.from_wallet && (
          <CardImg
            top
            width="100%"
            src={tokenSample.thumbnail_url}
            alt={tokenSample.token_id}
          />
        )}

        {tokenSample && !tokenSample.from_wallet && (
          <>
            <CardImg
              top
              width="100%"
              src={tokenSample.thumbnail_url}
              alt={tokenSample.token_id}
              style={{ opacity: 0.75 }}
            />
            <div className="position-relative">
              <div className="position-absolute bottom-0 end-0 pb-1 pe-1">
                <Badge color="white" pill className="text-dark px-3">
                  EXAMPLE
                </Badge>
              </div>
            </div>
          </>
        )}
        {unlockBoundaryData?.matching_tokens_count > 1 && (
          <div className="position-relative">
            <div className="position-absolute bottom-0 end-0 pb-1 pe-1">
              <Badge color="white" className="text-dark px-3">
                {unlockBoundaryData?.matching_tokens_count - 1}{" "}
                {context.t("more")}
              </Badge>
            </div>
          </div>
        )}
      </div>
      <p className="mt-3">{renderBoundaryType()}</p>
    </div>
  );
};

/**  define proptype for the 'translation' function  */
TribeBoundaryCard.contextTypes = {
  t: PropTypes.func,
};

TribeBoundaryCard.propTypes = {
  unlockBoundaryId: PropTypes.string,
};
/** export the component as redux connected component */
export default TribeBoundaryCard;
